"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7.5 20A1.5 1.5 0 0 1 6 18.5V8.65L4.7 6.702c-.488-.732-.255-1.757.539-2.18.296-.158.593-.293.959-.386C6.562 4.044 6.973 4 7.5 4c.532 0 .948.042 1.317.132.372.091.674.227.979.391.787.424.997 1.438.52 2.155L9 8.651V18.5A1.5 1.5 0 0 1 7.5 20M6.443 5.106a3 3 0 0 0-.734.299.52.52 0 0 0-.176.742L6.768 8h1.464l1.251-1.876a.505.505 0 0 0-.161-.72 3 3 0 0 0-.744-.3C8.312 5.037 7.982 5 7.5 5c-.471 0-.796.04-1.057.106m5.201.58A1.5 1.5 0 0 1 13.133 4h4.734c.902 0 1.6.79 1.489 1.686L18 16.531V18.5a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-1.969zM14 17v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V17z"
}), 'ProductsFilled');
